module.exports = __webpack_public_path__ + "img/gaoxin.ede95674.png";